import * as React from 'react';

import {Button} from '../../button/button';
import {SaveButton} from '../../button/save-button/save-button';
import {ButtonMover} from '../../button-mover/button-mover';
import {ButtonCard} from '../../card/button-card';
import {GridList} from '../../grid-list/grid-list';
import {InfoBanner} from '../../info-banner/info-banner';
import {FooterBar} from '../../modal/footer-bar';
import {Modal} from '../../modal/modal';
import {ModalBody} from '../../typography/modal-body';
import {ModalHeader} from '../../typography/modal-header';

import styles from './merge-items-modal.module.css';

type Item<I> = {
    id: string;
} & I;

type Props<I> = {
    title: string;
    subtitle: string;
    items: Item<I>[];
    renderItem: (item: Item<I>) => React.ReactElement;
    infoText: string;
    mergeButtonText: ((selectedItem?: Item<I> | null | undefined) => string) | string;
    mergingText?: string;
    onMergeItems: (selectedItem: Item<I>) => any;
    isMerging: boolean;
    onClose: () => any;
    maxHeight?: number;
};

export function MergeItemsModal<I>(props: Props<I>) {
    const [selectedItem, setSelectedItem] = React.useState<Item<I> | null | undefined>(null);

    return (
        <Modal
            isOpen={true}
            onClose={props.onClose}
            closeButton={false}
            maxHeight={props.maxHeight}
        >
            <div className={styles['merge-items-modal-content']}>
                <div className={styles.heading}>
                    <ModalHeader>{props.title}</ModalHeader>
                    <ModalBody>{props.subtitle}</ModalBody>
                </div>
                <div className={styles['items-container']}>
                    <GridList numColumns={2}>
                        {props.items.map((item) => (
                            <ButtonCard
                                key={item.id}
                                onClick={() =>
                                    props.isMerging ? undefined : setSelectedItem(item)
                                }
                                isSelected={Boolean(selectedItem && selectedItem.id === item.id)}
                                isFullWidth={true}
                                fitHeight={true}
                                showUnselectedOverlay={Boolean(selectedItem)}
                            >
                                {props.renderItem(item)}
                            </ButtonCard>
                        ))}
                    </GridList>
                </div>
                <InfoBanner>{props.infoText}</InfoBanner>
                <FooterBar
                    left={
                        <ButtonMover size='big' direction='left'>
                            <Button variant='text' size='big' onClick={props.onClose}>
                                Cancel
                            </Button>
                        </ButtonMover>
                    }
                    right={
                        <SaveButton
                            onClick={() =>
                                selectedItem ? props.onMergeItems(selectedItem) : undefined
                            }
                            isSaving={props.isMerging}
                            buttonText={
                                typeof props.mergeButtonText === 'string'
                                    ? props.mergeButtonText
                                    : props.mergeButtonText(selectedItem)
                            }
                            savingText={props.mergingText}
                            disabled={!selectedItem || props.isMerging}
                        />
                    }
                    noPadding={true}
                    fitHeight={true}
                />
            </div>
        </Modal>
    );
}
